var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-positioned-overlay', {
    attrs: {
      "full-width": _vm.fullWidth,
      "active": _vm.active,
      "preferred-position": _vm.preferredPosition,
      "activator-id": _vm.activatorId
    },
    on: {
      "scrollout": _vm.handleScrollOut
    },
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function(props) {
        return [_vm._t("overlay", null, {
          data: props
        })]
      }
    }])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-514b7b0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514b7b0a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisPopoverOverlay.vue
// module id = 204
// module chunks = 0